import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

function AppShell() {
  return (
    <div className="min-h-screen surface text-cyan-50">
      <Header />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

export default AppShell;
